@if (user.ID == -1 && !isResetPassword) {
<app-add-user></app-add-user>
}
@if (user.ID !== -1 && !isResetPassword) {
<app-edit-user

	[userToUpdate]="user"
	[admin]="true"
	[isInModal]="true"></app-edit-user>
}
@if (isResetPassword) {
<app-change-password

	[userToReset]="user"></app-change-password>
}
